import React from "react";
import { Skeleton } from "./ui/skeleton";

const ImageSkeleton = ({
  width = "100%",
  height = "200px",
  aspectRatio = "3/2",
  className = "",
  rounded = "md"
}) => {
  return (
    <div
      className={`relative overflow-hidden ${className}`}
      style={{
        width,
        height,
        aspectRatio: height === "auto" ? aspectRatio : undefined
      }}
    >
      <Skeleton
        className={`w-full h-full rounded-${rounded} animate-pulse`}
      />

      {/* Shimmer effect overlay */}
      <div
        className={`absolute inset-0 animate-shimmer bg-gradient-to-r from-transparent via-white/20 to-transparent rounded-${rounded}`}
      />
    </div>
  );
};

export default ImageSkeleton;